import * as React from 'react';
import {useSelector} from "react-redux";
import ProductDetailLeftContent from "./ProductDetail/ProductDetailLeftContent/ProductDetailLeftContent";

export function ProductDetailContentSeparatedComponent() {
    const productDetail = useSelector((state) => state.entities.model_ProductDetail.setProductDetail.data)
    return (
        <>
            <div className="logged-screen" style={{
                display: productDetail.value !== undefined && productDetail.value.ItemNumber !== undefined && !productDetail.ItemNumber ? '' : 'none'
            }}>
                <div className="content-area compare-open">
                    <div className="container">
                        <div className="bs5 row">
                            <ProductDetailLeftContent/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}
